export const orExteriorSwitcherMockData = {
  exteriorCount: 5,
  copy: {
    drawerTitle: 'Exterior Options',
    drawerSubtitle: 'All Options available',
    contentDescription: 'Exterior Styles',
  },
  exteriorStyles: [
    {
      id: 1,
      name: 'American Tradition',
      image: {
        src: {
          desktop: '/assets/home_plan.jpeg',
          tablet: '/assets/home_plan.jpeg',
          mobile: '/assets/home_plan.jpeg',
        },
        alt: 'Alt',
      },
    },
    {
      id: 2,
      name: 'Craftsman',
      image: {
        src: {
          desktop: '/assets/home_plan.jpeg',
          tablet: '/assets/home_plan.jpeg',
          mobile: '/assets/home_plan.jpeg',
        },
        alt: 'Alt',
      },
    },
    {
      id: 3,
      name: 'Modern Farmhouse',
      image: {
        src: {
          desktop: '/assets/home_plan.jpeg',
          tablet: '/assets/home_plan.jpeg',
          mobile: '/assets/home_plan.jpeg',
        },
        alt: 'Alt',
      },
    },
    {
      id: 4,
      name: 'Coastal',
      image: {
        src: {
          desktop: '/assets/home_plan.jpeg',
          tablet: '/assets/home_plan.jpeg',
          mobile: '/assets/home_plan.jpeg',
        },
        alt: 'Alt',
      },
    },
    {
      id: 5,
      name: 'Victorian',
      image: {
        src: {
          desktop: '/assets/home_plan.jpeg',
          tablet: '/assets/home_plan.jpeg',
          mobile: '/assets/home_plan.jpeg',
        },
        alt: 'Alt',
      },
    },
  ],
  selectedExterior: {
    id: 1,
    name: 'American Tradition',
    image: {
      src: {
        desktop: '/assets/home_plan.jpeg',
        tablet: '/assets/home_plan.jpeg',
        mobile: '/assets/home_plan.jpeg',
      },
      alt: 'Alt',
    },
  },
  onExteriorSelect: () => console.log('select'),
};
